@use "../../../../shared/scss" as *;

.model-signature {
  block-size: var(--signature-size, (26px));

  @include pds-media-query-min("xxl") {
    block-size: var(--signature-size, (30px));
  }
}

phn-p-text {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: $pds-theme-light-contrast-high;
  font-size: p-px-to-rem(20px);

  @include pds-media-query-min("xxl") {
    font-size: p-px-to-rem(24px);
  }
}
